import Image from "next/legacy/image";
import { Accordion, ArrowUp, Button } from 'ui';

export default function BlogCTAMobile () {
  return <Accordion initialIsOpen>
    {({ isOpened }) => (
      <div className="shadow-auth bg-beige p-4 pt-[15px] rounded-lg">
        <div className="flex">
          <div className="flex-none mr-4">
            <Image
              src="/images/blog-cta-question-mark.svg"
              width={55}
              height={55}
              alt=""
              unoptimized={true}
              objectFit="contain"
            />
          </div>
          <Accordion.Header className="inline-flex items-center cursor-pointer transition-all text-left">
            <span className="mr-2 tp-header-4">
            Don’t know your personality type?
            </span>
            <ArrowUp
              isOpen={isOpened}
              className="w-[35px] text-black"
            />
          </Accordion.Header>
        </div>
        <Accordion.Content>
          <Button
            href="/free-personality-test"
            as="a"
            className="!shadow-brown active:!shadow-green-inset mt-4 w-full"
          >
          Take the test now
          </Button>
        </Accordion.Content>
      </div>
    )}
  </Accordion>
}